import copy from 'fast-copy';
import isEqual from 'react-fast-compare';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import React, { useState, useEffect, useRef } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import _ from 'lodash';
import { Button, Select, MenuItem, FormControl } from '@material-ui/core';

import { updateSavedGroups, updateSavedLocations, updateSavedScenario } from '../../../Functions/user';

import { colors, roles, sharingValues, modules } from '../../../Shared/utils';
import { getScenarios } from '../../../Functions/scenarios';
import { useAppContext } from '../../../Context/App/Provider';
import { useEventContext } from '../../../Context/Event/Provider';
import { useReportingContext } from '../../../Context/Reporting/Provider';
import { changeSettings, getPreciseTime, multiSelectStrings } from '../../../Functions/utils';

import GroupSelect from "./GroupSelect";
import PeriodSelect from './PeriodSelect';
import LocationSelect from './LocationSelect';

import './Sidebar.css';


const showScenarios = async (setLoading, pickers, selected, dispatch, user, groups = null, sites = null) => {
  // console.log("28 - showScenarios - groups=", groups, selected);

  if (!sites) {
    sites = [];
    selected.locations.forEach(loc => { // 2nd part only necessary for admins
      if (loc.group) return sites.push(loc.value); // return the group's locations if the selected item is a group
      return pickers.locations.show.filter(all => all.group === loc.value).forEach(site => sites.push(site.value));
    });
  }

  // if (!groups) {
  //   groups = [];
  //   selected.groups.forEach(grp => { // 2nd part only necessary for admins
  //     groups.push(grp.value);
  //     // if (grp.group) return sites.push(grp.value); // return the group's locations if the selected item is a group
  //     // return pickers.locations.show.filter(all => all.group === loc.value).forEach(site => sites.push(site.value));
  //   });
  // }

  // console.log("33 - groups=", groups);

  if (sites.length === 0) {
    dispatch({ scenario: null, scenarios: null });
    return [];
  }

  setLoading(true);
  // [...new Set()] removes duplicates from the sites
  // if selected a group + its locations in the picker
  const res = await getScenarios([...new Set(sites)], 2);
  // console.log("41 - getScenarios=", res);

  const scenarios = res.success ? res.scenarios : [];

  // TO DO : Reorder 
  // console.log("49 - res.scenarios=", res.scenarios);
  // console.log("50 - user.scenariosOrder=", user.scenariosOrder);

  // scenarios.sort(function (a, b) {
  //   if (user.scenariosOrder.indexOf(a.id) < user.scenariosOrder.indexOf(b.id)) {
  //     return -1;
  //   }
  //   return 1;
  // });
  // console.log("62 - scenarios=", scenarios);

  // console.log("74 - scenarios=", scenarios);

  dispatch({ scenarios, scenario: null });
  setLoading(false);

  // console.log("49 - showScenarios=", scenarios);
  return scenarios;
};


export default function Sidebar() {
  const { t } = useTranslation();
  const [{ sidebar, settings, user, /*forceReloadScenario,*/ loading }, appDispatch] = useAppContext(); // global context
  const [{ pickers, selected, scenario: selectedScenario, scenarios, module: selectedModule }, dispatch] = useReportingContext(); // reporting context
  const [{ groupsLocationsStatus, scenariosStatus, modulesStatus, deploymentsStatus, autoApply, canApply, refreshSelectedLocations }, eventDispatch] = useEventContext();

  // console.log("72 - user=", user);
  // console.log("73 - settings=", settings);
  // console.log("60 - pickers=", pickers);
  // console.log("61 - selected=", selected);
  // console.log("62 - scenarios=", scenarios);

  // console.log("63 - selectedModule=", selectedModule);
  // console.log("64 - selectedScenario=", selectedScenario);

  // if period has "," -> user has manually set precise period dates
  const [precise, setPrecise] = useState(settings.period.includes(','));
  const [periods, setPeriods] = useState([getPreciseTime(settings.period, 'start'), getPreciseTime(settings.period, 'end')]);

  //const [modeScenariosOrModules, setModeScenariosOrModules] = useState(settings.mode || 'scenarios');

  // all_scenarios, sft_scenarios, allGroups_scenarios, currentGroups_scenarios, myShared_scenarios, myPrivate_scenarios, modules
  // const [modeScenariosOrModules, setModeScenariosOrModules] = useState(settings.mode || 'all_scenarios');

  const [modeScenariosOrModules, setModeScenariosOrModules] = useState(
    settings.mode === 'all_scenarios' ||
      settings.mode === 'myShared_scenarios' ||
      settings.mode === 'myPrivate_scenarios' ||
      settings.mode === 'sft_scenarios' ||
      settings.mode === 'allGroups_scenarios' ||
    settings.mode === 'currentGroups_scenarios' ||
    settings.mode === 'modules' ? settings.mode : 'all_scenarios'
  );

  // auto-load scenarios if user has selected location(s)
  const load = useRef(selected.locations.length > 0);
  const [loadingScenarios, setLoadingScenarios] = useState(false);
  const [firstLog, setFirstLog] = useState(true);

  // const prevGroups = useRef(selected.groups);
  const prevLocs = useRef(selected.locations);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState(selected.locations);

  // const [refreshScenarioList, setRefreshScenarioList] = useState(false);
  // const [canApply, setCanApply] = useState(false);
  // const [forceApply, setForceApply] = useState(true);

  // const [count, setCount] = useState(0);


  const handleChangePeriod = (period, type = null) => {
    // console.log("125 - type=", type);
    // console.log("126 - period=", period);

    if (type) { // user uses precise period
      const newPeriod = new Date(period).setHours(0, 0, 0, 0);
      const time = new Date(newPeriod).getTime();

      if (isNaN(time) || time <= 0)
        return;

      if (type === 'start') { // adjust new period accordingly if it is already manually set or not 
        period = [time, getPreciseTime(settings.period, 'end')];
      }
      else {
        period = [getPreciseTime(settings.period, 'start'), time];
      }
      setPeriods(period);

    } else { // user uses a pre-defined time period

      changeSettings(t, 'period', period, settings, appDispatch);
      setPeriods([getPreciseTime(period, 'start'), getPreciseTime(period, 'end')]);
    }

    // if (selectedScenario === null && modeScenariosOrModules === "scenarios")
    if (selectedScenario === null && modeScenariosOrModules !== "modules")
      eventDispatch({ scenariosStatus: "pending", canApply: 'on' });
    else if (scenariosStatus !== "pending")
    eventDispatch({ deploymentsStatus: "pending", canApply: 'on' });
    // setCanApply(true);
  };


  // GROUPS
  const handleChangeGroups = (selectedGroups, newGroups) => {
    // console.log("139 - set groups=", newGroups);
    handleSetGroups(true, newGroups);
  };


  const handleSetGroups = (force = false, newGroups = []) => {

    // console.log("161 - force=", force);
    // console.log("164 - newGroups=", newGroups);

    // console.log("166 - selected.groups=", selected.groups);
    // console.log("167 - selectedGroups=", selectedGroups);

    // console.log("169 - pickers=", pickers);
    // console.log("170 - selected=", selected);

    // console.log("149 - isEqual(selected.groups, selectedGroups)=", isEqual(selected.groups, selectedGroups));
    if (
      !isEqual(selected.groups, selectedGroups) ||
      force
    ) {
      // const groups = (!force) ? copy(selectedGroups) : copy([]);
      const groups = copy(selected.groups);

      const groupList = [];
      for (const group of groups) {
        groupList.push(group.value);
      }
      updateSavedGroups(JSON.stringify(groupList));

      setSelectedGroups(selected.groups);

      const newGroupList = [];
      for (const group of newGroups) {
        newGroupList.push(group.value);
      }

      // if user unselects all groups (manually or with the x icon)
      if (groups.length === 0) {
        handleSetLocations([]);
        return dispatch({ selected: { groups: [], locations: [] } });
      }

      // remove selected locations from unselected groups
      const groupIds = [], newLocations = [];
      groups.sort((a, b) => a.sort - b.sort).forEach(group => groupIds.push(group.value));

      pickers.locations.show.forEach(loc => {
        // if loc.group is undefined, it's for selecting the entire group so the group is loc.value
        if (groupIds.includes(loc.group ?? loc.value) && selected.locations.some(l => l.value === loc.value)) {
          newLocations.push(loc);
        }
      });


      pickers.locations.all.filter(loc => {
        const array = [];
        groups.forEach(group => array.push(group.value));

        // Show non-indented group name if multiple groups are selected              
        return array.includes(loc.group ?? (groups.length === 1 ? null : loc.value));
      }).forEach(loc => {
        if (newGroupList.includes(loc.group)) {
          newLocations.push(loc);
        }
      });
      // console.log("218 - newLocations=", newLocations);

      const locationList = [];
      for (const location of newLocations) {
        locationList.push(location.value);
      }
      updateSavedLocations(JSON.stringify(locationList));

      dispatch({
        pickers: {
          ...pickers,
          locations: {
            all: pickers.locations.all,
            show: groups.length === 0 ? [] : pickers.locations.all.filter(loc => {
              const array = [];
              groups.forEach(group => array.push(group.value));

              // Show non-indented group name if multiple groups are selected
              return array.includes(loc.group ?? (groups.length === 1 ? null : loc.value));
            })
          }
        },
        selected: {
          locations: newLocations,
          groups
        }
      });

      // appDispatch({
      //   refreshScenarios: true
      // });
      eventDispatch({ scenariosStatus: "pending", canApply: 'on' });
      // setCanApply(true);
      // setRefreshScenarioList(true);
    }
  };


  // LOCATIONS 
  const handleChangeLocations = (locations) => {
    // setSelectedLocations(locations);

    // if (locations.length === 0) {
    handleSetLocations();
    // }
  };


  const handleSetLocations = (force = false) => {

    // console.log("273 - handleSetLocations=", force);
    // console.log("274 - selected.locations=", selected.locations);
    // console.log("247 - selectedLocations=", selectedLocations);
    // console.log("149 - isEqual(selected.locations, selectedLocations)=", isEqual(selected.locations, selectedLocations));

    if (
      !isEqual(selected.locations, selectedLocations) ||
      force
    ) {
      // const locations = (!force) ? copy(selectedLocations) : copy([]);
      const locations = copy(selected.locations);
      const filteredLocations = [];

      const locationList = [];
      for (const location of locations) {
        if (location.group) {
          filteredLocations.push(location);
        locationList.push(location.value);
      }
      }
      updateSavedLocations(JSON.stringify(locationList));
      setSelectedLocations(selected.locations);

      dispatch({
        selected: {
          ...selected,
          // Sort selected locations in the pickers order
          locations: filteredLocations.sort((a, b) => a.sort - b.sort)
        }
      });

      // appDispatch({
      //   refreshScenarios: true
      // });
      // setApplyButton
      eventDispatch({ scenariosStatus: "pending", canApply: 'on' });
      // setCanApply(true);

      // if (filteredLocations.length === 0)
      //   handleLoadScenarios({ sites: [] });
      // else {
      //   dispatch({ refreshLocations: true });
      //   // setRefreshScenarioList(true);
      // }
    }
  };


  const handleChangeScenario = (selected) => {
    // console.log("339 - handleChangeScenario - selected=", selected);
    dispatch({scenario:selected.scenario});
    updateSavedScenario(selected.scenario);

    // console.log("211 - selected=", selected);
    // changeSettings(t, 'scenario', selected.scenario ? selected.scenario.id : null, settings, appDispatch);
    
    // eventDispatch({ deploymentsStatus: "force" });

    if (deploymentsStatus !== "force") 
    eventDispatch({ deploymentsStatus: "force" });
      else 
        eventDispatch({ deploymentsStatus: "forceForce" });
  };

  const handleChangeModule = (module) => {
    // console.log("246 - module=", module);
    dispatch(module);
    // eventDispatch({ deploymentsStatus: "force" });
    if (deploymentsStatus !== "force") 
    eventDispatch({ deploymentsStatus: "force" });
      else 
        eventDispatch({ deploymentsStatus: "forceForce" });
  };

  const handleSetModeScenariosOrModules = (mode) => {
    setModeScenariosOrModules(mode);

    changeSettings(t, 'mode', mode, settings, appDispatch);
    document.querySelector('#modeScenariosOrModules').classList.toggle('open');

    // if (mode === "scenarios") {
    //   console.log("260 - scenario=", selectedScenario);
    //   setRefreshScenarioList(true);
    //   // const selected = {};
    //   // selected.scenario = selectedScenario;
    //   // dispatch(selected);
    // }
  };


  const handleLoadScenarios = ({ sites = null, force = false }) => {
    // console.log('163 - handleLoadScenarios=', prevLocs.current, selected.locations, selectedLocations);

    // if (modeScenariosOrModules === 'modules') {
    //   // eventDispatch({ deploymentsStatus: "force" });
    //   eventDispatch({ scenariosStatus: "loaded", deploymentsStatus: "force" });
    //   return;
    // }

    if (!isEqual(prevLocs.current, selected.locations) || sites || force) {

      eventDispatch({ scenariosStatus: "loading" });

      const scenario = copy(selectedScenario);
      // console.log("393 - handleLoadScenarios...");
      dispatch({ scenario: null });

      // sites is not null (empty array) when unselecting all locations
      prevLocs.current = sites ?? selected.locations;

      showScenarios(setLoadingScenarios, pickers, selected, dispatch, user, sites).then(scenarios => {
        if (scenarios.find(s => isEqual(s, selectedScenario))) {
          // automatically re-select scenario and refresh deployments if the scenario is still in the list
          // console.log("252 - scenario=", scenario);
          // console.log("403 - handleLoadScenarios...");
          dispatch({ scenario });
        }
        eventDispatch({ scenariosStatus: "loaded" });
      });
    }
    else if (deploymentsStatus === "pending") {
      eventDispatch({ scenariosStatus: "loaded", deploymentsStatus: "force" });
    }
    else
      eventDispatch({ scenariosStatus: "idle" });
  };


  const handleApply = () => {

    // console.log("382 - handleApply=", scenariosStatus, deploymentsStatus);
    // setCanApply(false);

    if (scenariosStatus === "pending") {
      eventDispatch({
        scenariosStatus: "force",
        canApply: 'off'
      });
    }
    else if (deploymentsStatus === "pending") {
      eventDispatch({ deploymentsStatus: "force", scenariosStatus: "idle", canApply: 'off' });
    }
    else {
      eventDispatch({
        scenariosStatus: "force",
        canApply: 'off'
      });
    }
  }




  // // GROUPS/LOCATIONS STATUS
  // useEffect(() => {// canApply
  //   console.log("397 - useEffect... canApply=", canApply);

  //   if (forceApply && canApply) {

  //     setForceApply(false);
  //     eventDispatch({ scenariosStatus: "pending" });
  //     handleApply();
  //   }

  // }, [forceApply]);


  // GROUPS/LOCATIONS STATUS
  useEffect(() => {// groupsLocationsStatus
    // console.log("424 - useEffect... groupsLocationsStatus=", groupsLocationsStatus);

    if (groupsLocationsStatus === "loaded") {

      // console.log("416 - scenariosStatus=", scenariosStatus);
      // console.log("416 - deploymentsStatus=", deploymentsStatus);

      if (refreshSelectedLocations === "on") {
        const locations = copy(selected.locations);
        const filteredLocations = [];

        const locationList = [];
        for (const location of locations) {
          if (location.group) {
            filteredLocations.push(location);
            locationList.push(location.value);
          }
        }
        updateSavedLocations(JSON.stringify(locationList));
        setSelectedLocations(selected.locations);
      }

      // console.log("401 - selected.locations=", selected.locations);
      // console.log("402 - selectedLocations=", selectedLocations);

      // // let tmpLocations = selectedLocations.filter(loc => loc.group && selected.locations.includes(loc.value))
      // // console.log("420 - selectedLocations=", tmpLocations);
      // setSelectedLocations(selected.locations);

      if (scenariosStatus === "pending" || autoApply === "on") {
        eventDispatch({ refreshSelectedLocations: "off", groupsLocationsStatus: "idle", scenariosStatus: "full-force", autoApply: "off" });
      }
      else if (deploymentsStatus === "pending") {
        eventDispatch({ refreshSelectedLocations: "off", groupsLocationsStatus: "idle", deploymentsStatus: "force" });
      }
      else
        eventDispatch({ refreshSelectedLocations: "off", groupsLocationsStatus: "idle"/*, scenariosStatus: "pending"*/ });
    }
  }, [groupsLocationsStatus]);




  // SCENARIOS STATUS
  useEffect(() => {// scenariosStatus
    // console.log("469 - useEffect... scenariosStatus=", scenariosStatus, deploymentsStatus);

    if (scenariosStatus === "pending") {

    }
    else if (scenariosStatus === "full-force") {
      eventDispatch({ scenariosStatus: "loading" });
      handleLoadScenarios({ force: true });
    }
    else if (scenariosStatus === "force") {
      eventDispatch({ scenariosStatus: "loading" });
      handleLoadScenarios({ force: (!scenarios || deploymentsStatus === "pending") });
    }
    else if (scenariosStatus === "loading") {

      // eventDispatch({ scenariosStatus: "pending" });

    }
    else if (scenariosStatus === "loaded") {
      // eventDispatch({
      //   scenariosLoaded: false
      // });

      // console.log("441 - scenarios=", scenarios);
      // console.log("442 - selected.locations.length=", selected.locations.length);
      // console.log("443 - selectedScenario=", selectedScenario);

      // if (load.current && !scenarios) {
      if (selected.locations.length > 0 && !scenarios) {
        // load.current = false;
      showScenarios(setLoadingScenarios, pickers, selected, dispatch, user);
    }
    else {

      if (selectedScenario === null) {
        let found = false;

        if (scenarios) {
        const scenarioId = (user.savedScenario ? user.savedScenario : '1144');

          for (const scenario of scenarios) {
            if (scenario.id == scenarioId) {      // == since ScenarioId is number/string
              const selected = {
                scenario: scenario
              }
              found = true;
                // console.log("465 - selected=", selected);
                // console.log("550 - useEffect...scenariosStatus=", scenariosStatus);
              dispatch(selected);
              // doDispatch = true;
            }
          }

          if (!found) {
            for (const scenario of scenarios) {
              if (scenario.id == '1144') {        // == since ScenarioId is number/string
                const selected = {
                  scenario: scenario
                }
                found = true;
                // console.log("321 - selected=", selected);
                  // console.log("564 - useEffect...scenariosStatus=", scenariosStatus);
                dispatch(selected);
              }
            }
          }
        }
      }

      if (selectedModule === null) {
        const selected = {
          module: 1101
        }
        dispatch(selected);
      }
    }

      //if (modeScenariosOrModules === 'scenarios')
        eventDispatch({ scenariosStatus: "idle", deploymentsStatus: (deploymentsStatus !== "force" ? "force": "forceForce") });
      //else
      //  eventDispatch({ scenariosStatus: "idle" });
    }
  }, [scenariosStatus]);




  // useEffect(() => {
  //   // console.log("334 - useEffect=", refreshScenarioList, forceReloadScenario);

  //   // auto-load deployments if user has location(s) selected
  //   if (refreshScenarioList) {
  //     handleLoadScenarios({});
  //     setRefreshScenarioList(false);
  //   }
  //   else if (forceReloadScenario) {
  //     handleLoadScenarios({ force: true });
  //     appDispatch({ forceReloadScenario: false });
  //   }

  //   // Only for the 1st log of a group admin.
  //   if (
  //     user.roleId === roles.admin &&
  //     user.groups.length > 0 &&
  //     user.savedLocations === null &&
  //     selected.locations.length === 0 &&
  //     firstLog === true
  //   ) {
  //     console.log("195 - First log");
  //     setFirstLog(false);

  //     console.log('==> select ALL');
  //     handleSetLocations(pickers.locations.show);

  //     Array.prototype.push.apply(selected.locations, pickers.locations.show);
  //     showScenarios(setLoadingScenarios, pickers, selected, dispatch, user);
  //   }
  //   //------------

  //   if (load.current && !scenarios) {
  //     load.current = false;
  //     showScenarios(setLoadingScenarios, pickers, selected, dispatch, user);
  //   }
  //   else {

  //     if (selectedScenario === null) {
  //       let found = false;

  //       if (scenarios) {
  //         const scenarioId = (user.savedScenario ? user.savedScenario : '1144');

  //         for (const scenario of scenarios) {
  //           if (scenario.id == scenarioId) {      // == since ScenarioId is number/string
  //             const selected = {
  //               scenario: scenario
  //             }
  //             found = true;
  //             // console.log("308 - selected=", selected);
  //             dispatch(selected);
  //             // doDispatch = true;
  //           }
  //         }

  //         if (!found) {
  //           for (const scenario of scenarios) {
  //             if (scenario.id == '1144') {        // == since ScenarioId is number/string
  //               const selected = {
  //                 scenario: scenario
  //               }
  //               found = true;
  //               // console.log("321 - selected=", selected);
  //               dispatch(selected);
  //             }
  //           }
  //         }
  //       }
  //     }

  //     if (selectedModule === null) {
  //       const selected = {
  //         module: 1101
  //       }
  //       dispatch(selected);
  //     }
  //   }
  //   setSelectedGroups(selected.groups);
  //   setSelectedLocations(selected.locations);

  // }, [load, pickers, selected, scenarios, dispatch, setLoadingScenarios, setSelectedGroups, setSelectedLocations]);


  // useEffect(() => {// scenariosLoaded
  //   console.log("459 - useEffect... scenariosLoaded=", scenariosStatus);

  //   if (scenariosStatus === "loaded") {
  //     // eventDispatch({
  //     //   scenariosLoaded: false
  //     // });

  //     console.log("441 - scenarios=", scenarios);
  //     console.log("442 - selected.locations.length=", selected.locations.length);
  //     console.log("443 - selectedScenario=", selectedScenario);

  //     // if (load.current && !scenarios) {
  //     if (selected.locations.length > 0 && !scenarios) {
  //       // load.current = false;
  //       showScenarios(setLoadingScenarios, pickers, selected, dispatch, user);
  //     }
  //     else {

  //       if (selectedScenario === null) {
  //         let found = false;

  //         if (scenarios) {
  //           const scenarioId = (user.savedScenario ? user.savedScenario : '1144');

  //           for (const scenario of scenarios) {
  //             if (scenario.id == scenarioId) {      // == since ScenarioId is number/string
  //               const selected = {
  //                 scenario: scenario
  //               }
  //               found = true;
  //               console.log("465 - selected=", selected);
  //               dispatch(selected);
  //               // doDispatch = true;
  //             }
  //           }

  //           if (!found) {
  //             for (const scenario of scenarios) {
  //               if (scenario.id == '1144') {        // == since ScenarioId is number/string
  //                 const selected = {
  //                   scenario: scenario
  //                 }
  //                 found = true;
  //                 // console.log("321 - selected=", selected);
  //                 dispatch(selected);
  //               }
  //             }
  //           }
  //         }
  //       }

  //       if (selectedModule === null) {
  //         const selected = {
  //           module: 1101
  //         }
  //         dispatch(selected);
  //       }
  //     }

  //     if (modeScenariosOrModules === 'scenarios')
  //       eventDispatch({ scenariosStatus: "idle", deploymentsStatus: "force" });
  //     else
  //       eventDispatch({ scenariosStatus: "idle" });
  //   }
  //   // setSelectedGroups(selected.groups);
  //   // setSelectedLocations(selected.locations);
  // }, [scenariosStatus]);


  // useEffect(() => { //refreshDeployments
  //   console.log("532 - useEffect... deploymentsStatus=", deploymentsStatus);
  // }, [deploymentsStatus]);


  // useEffect(() => { //load
  //   console.log("528 - useEffect... load=", load);

  //   eventDispatch({
  //     refreshScenarios: true
  //   });
  // }, [load]);


  // useEffect(() => { //refreshGroups
  //   console.log("510 - useEffect... groupsLocationsStatus=", groupsLocationsStatus);

  //   // if (groupsPending) {
  //   //   eventDispatch({
  //   //     refreshGroups: true,
  //   //     groupsPending: false
  //   //   });
  //   // }
  // }, [groupsLocationsStatus]);



  // useEffect(() => { //groupsLocationsStatus
  //   console.log("599 - useEffect... groupsLocationsStatus=", groupsLocationsStatus);

  //   // if (groupsLoaded || locationsLoaded) {
  //   //   eventDispatch({
  //   //     scenariosPending: true,
  //   //     groupsLoaded: false,
  //   //     locationsLoaded: false
  //   //   });

  //   //   console.log("608 - call handleApply");
  //   //   handleApply();

  //   if (scenariosPending) {
  //     eventDispatch({
  //       scenariosPending: false,
  //       deploymentsPending: true,
  //       refreshScenarios: true
  //     });
  //   }
  //   else if (deploymentsPending) {
  //     eventDispatch({
  //       deploymentsPending: false,
  //       scenariosPending: false,
  //       refreshDeployments: true
  //     });
  //   }
  //   else {
  //     eventDispatch({
  //       groupsLoaded: false,
  //       locationsLoaded: false,
  //     });
  //   }
  // }, [groupsLoaded, locationsLoaded]);


  // useEffect(() => {// refreshScenarios
  //   console.log("568 - useEffect... refreshScenarios=", refreshScenarios);

  //   if (refreshScenarios) {
  //     eventDispatch({
  //       refreshScenarios: false
  //     });
  //     handleLoadScenarios({ force: (!scenarios || deploymentsPending) });
  //   }
  // }, [refreshScenarios]);


  // useEffect(() => {// refreshDeployments
  //   console.log("553 - useEffect... refreshDeployments=", refreshDeployments);

  //   if (refreshDeployments) {
  //     eventDispatch({
  //       refreshDeployments: false
  //     });
  //   }
  // }, [refreshDeployments]);


  useEffect(() => {
    // console.log("557 - useEffect...");

    // console.log("418 - useEffect...");
    const dropdown = (e) => {
      if (typeof e.target.className === 'string' && !e.target.className.includes('dropdown')) {
        document.querySelector('#modeScenariosOrModules') && document.querySelector('#modeScenariosOrModules').classList.remove('open');
      }
    };
    document.addEventListener('click', dropdown);
    return () => document.removeEventListener('click', dropdown);
  }, [t]);


  // const itemRenderer = ({
  //   checked,
  //   option,
  //   onClick,
  //   disabled,
  // }) => {

  //   if (user.roleId !== roles.stAdmin || (option.value === "" || (option.label && option.label.charAt(0) === '\u2001'))) {
  //     return (
  //       <div className={`item-renderer ${disabled && "disabled"}`}>
  //         <input
  //           type="checkbox"
  //           onChange={onClick}
  //           checked={checked}
  //           tabIndex={-1}
  //           disabled={disabled}
  //         />
  //         <span>{option.label}</span>
  //       </div>
  //     )
  //   }
  //   else {
  //     return (
  //       <div className={`item-renderer ${disabled && "disabled"}`}>
  //         <input
  //           type="hidden"
  //           onChange={onClick}
  //           checked={checked}
  //           tabIndex={-1}
  //           disabled={true}
  //         />
  //         <span style={{ color: colors.softthinks, fontSize: "120%" }}>{option.label}</span>
  //       </div>
  //     )
  //   }
  // };

  // console.log("446 - ...", selectedGroups, selectedLocations, scenarios);

  let tmpStr = 'sidebar.scenarios.' + modeScenariosOrModules;
  let modeScenariosOrModulesText = t(tmpStr);
  if (modeScenariosOrModules === 'modules')
    modeScenariosOrModulesText = t('scenarios.modules.title', { s: 's' });


  // console.log("855 - groupsLocationsStatus=", groupsLocationsStatus);
  // console.log("856 - scenariosStatus=", scenariosStatus);
  // console.log("857 - deploymentsStatus=", deploymentsStatus);

  // console.log("859 - canApply=", canApply);
  // console.log("860 - refreshSelectedLocations=", refreshSelectedLocations);


  // console.log("796 - selected=", selected);
  // console.log("797 - selectedLocations=", selectedLocations);
  // console.log("10050 - periods=", periods);
  // console.log("887 - user=", user);
  // console.log("889 - scenarios=", scenarios);
  // console.log("885 - modeScenariosOrModules=", modeScenariosOrModules);

  const filteredScenarios = _.filter(scenarios, scenario => {
    let keepIt = true;

    // console.log("802 - scenario=", scenario);
    switch (modeScenariosOrModules) {
      case "all_scenarios":
        return true;
        break;

      case "myGroup_scenarios": {
        if (scenario.groups && scenario.groups.length > 0) {
          let test = scenario.groups.find(element => {
            // console.log("946 - element=", element);
            return (element === user.groupId);
          })
          return (test);
        }
        break;
      }

      case "myShared_scenarios": {
        if (user.id === scenario.owner && scenario.sharingOptions !== sharingValues.noOne)
          return true;
        break;
      }

      case "myPrivate_scenarios": {
        if (user.id === scenario.owner && scenario.sharingOptions === sharingValues.noOne)
          return true;
        break;
      }

      case "sft_scenarios": {
        if (user.roleId <= roles.stAdmin && scenario.sharingOptions === sharingValues.allStAdmins)
          return true;
        break;
      }

      case "allGroups_scenarios": {
        if (
          user.roleId <= roles.stAdmin && scenario.groups && scenario.groups.length > 0 //(
          //   scenario.sharingOptions === sharingValues.allGroupAdmins || scenario.sharingOptions === sharingValues.allGroupUsers
          // )
        )
          return true;
        break;
      }

      case "currentGroups_scenarios": {
        // console.log("938 - scenario=", scenario);

        if (user.roleId <= roles.stAdmin && scenario.groups && scenario.groups.length > 0 && selected && selected.groups) {
          //   scenario.sharingOptions === sharingValues.allGroupAdmins || scenario.sharingOptions === sharingValues.allGroupUsers
          // let test = selected.groups.find(element => {
          //   retscenario.groups[0] 
          // })       
          let test = selected.groups.find(element => {
            // console.log("946 - element=", element.value, scenario.groups[0], element.value === scenario.groups[0]);
            return (element.value === scenario.groups[0]);
          })
          //console.log("949 - test=", test);  
          return (test);
        }
        return false;
        break;
      }

      default:
        return false;
    }

    return false;
  });


  return <>
    <div className={'sidebar__bg' + (sidebar ? '' : ' hidden')} />
    <div className={'sidebar' + (sidebar ? '' : ' hidden')}>
      <div className="sidebar__content">
        <hr /><h2 className="sidebar__title">{t('sidebar.filters.title')}</h2>

        <div className="sidebar__select">
          <div style={{ display: 'flex' }}>
            <p className="sidebar__label" style={{ flexGrow: 1 }}>{t('sidebar.filters.period.title')}</p>
            <span
              className="material-icons-round"
              onClick={() => setPrecise(!precise)}
              style={precise ? { color: colors.softthinks } : {}}
            >tune</span>
          </div>

          {precise ? (
            <>
              <div className="periodSelect" style={{ marginBottom: '10px' }}>
                <p>{t('sidebar.filters.period.start')}</p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker disabled={loading} value={periods[0]} onChange={date => handleChangePeriod(date, 'start')}
                    onBlur={() => changeSettings(t, 'period', periods.join(','), settings, appDispatch)}
                    onClose={() => changeSettings(t, 'period', periods.join(','), settings, appDispatch)}

                    format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                    placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}

                    disableToolbar variant="inline" inputVariant="outlined" InputAdornmentProps={{ position: 'start' }}
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="periodSelect">
                <p>{t('sidebar.filters.period.end')}</p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker disabled={loading} value={periods[1]} onChange={date => handleChangePeriod(date, 'end')}
                    onBlur={() => changeSettings(t, 'period', periods.join(','), settings, appDispatch)}
                    onClose={() => changeSettings(t, 'period', periods.join(','), settings, appDispatch)}

                    format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                    placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}

                    disableToolbar variant="inline" inputVariant="outlined" InputAdornmentProps={{ position: 'start' }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </>
          ) : (
            <div>
              {/* <select
              className="singleSelect"
              title={t('sidebar.filters.period.title')}
              onChange={e => handleChangePeriod(e.target.value)}
              defaultValue={settings.period.includes(',') ? 'choose' : settings.period}
            >
              <option value="choose" hidden>{t('sidebar.filters.period.select')}</option>
              <option value="0">{t('sidebar.filters.period.today')}</option>
              <option value="24">{t('sidebar.filters.period.last_24h')}</option>
              <option value="-1">{t('sidebar.filters.period.yesterday')}</option>
              <option value="0w">{t('sidebar.filters.period.current_week')}</option>
              <option value="7">{t('sidebar.filters.period.last_7d')}</option>
              <option value="-1w">{t('sidebar.filters.period.previous_week')}</option>
              <option value="0m">{t('sidebar.filters.period.current_month')}</option>
              <option value="30">{t('sidebar.filters.period.last_30d')}</option>
              <option value="-1m">{t('sidebar.filters.period.previous_month')}</option>
              <option value="60">{t('sidebar.filters.period.last_60d')}</option>
              <option value="6m">{t('sidebar.filters.period.last_6m')}</option>
              </select> */}

              <PeriodSelect
                onChangePeriod={period => handleChangePeriod(period)}
              />
            </div>
          )}
        </div>

        {/* {user.roleId === roles.stAdmin && (
          <div className="sidebar__select">
            <p className="sidebar__label">{t('sidebar.filters.groups')}</p>
            <MultiSelect
              value={selectedGroups}
              options={pickers.groups}
              overrideStrings={multiSelectStrings(t, 'grp')}
              onChange={groups => handleChangeGroups(groups)} // Show relevant locations on group select
              onMenuToggle={visible => !visible && handleSetGroups()} // Refresh scenarios if needed
              ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
              valueRenderer={(items) => {
                const values = items.map(loc => loc.label).join(', ');
                return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t, 'grp').selectSomeItems;
              }}
              CrossIcon
            />
          </div>
        )} */}

        {user.roleId <= roles.stAdmin && (
          <div className="sidebar__select">
            <p className="sidebar__label">{t('sidebar.filters.groups')}</p>
            <GroupSelect
              onChangeGroups={handleChangeGroups}
            />
          </div>
        )}

        {/* {(pickers.locations.show.length > 1 || user.roleId !== roles.user) && (
          <div className={'sidebar__select' + (selected.groups.length > 0 ? '' : ' disabled')}>
            <p className="sidebar__label">{t('sidebar.filters.locations')}</p>
            <MultiSelect
              ItemRenderer={itemRenderer}
              value={selectedLocations}
              options={pickers.locations.show}
              disabled={selected.groups.length === 0} // no group
              overrideStrings={multiSelectStrings(t, 'loc', selected)}
              onChange={locations => handleChangeLocations(locations)}
              onMenuToggle={visible => !visible && handleSetLocations()}
              ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
              valueRenderer={(items) => {
                const values = items.map(loc => loc.label.replace('\u2001', '-')).join(', ');
                return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t, 'loc', selected).selectSomeItems;
              }}
            />
          </div>
        )} */}

        {(pickers.locations.show.length > 1 || user.roleId !== roles.user) && (
          <div className={'sidebar__select' + (selected.groups.length > 0 ? '' : ' disabled')} disabled>
            <p className="sidebar__label">{t('sidebar.filters.locations')}</p>

            <LocationSelect
              // initialSelection={selected.locations}
              onChangeLocations={handleChangeLocations}
            />
          </div>
        )}

        {canApply === 'on' && selectedLocations.length > 0 && (

          <div className="sidebar__select">
            <p className="sidebar__label">{ }</p>
            <Button
              className="button"
              style={{
                // opacity: (canApply === 'on') ? '1' : '0',
                backgroundColor: 'white',
                border: '1px solid ' + colors.softthinks,
                width: '100%',
                maxWidth: '100%',
                height: '34px',
                opacity: (loading) ? '0.4' : (canApply === 'on') ? '1' : '0',
                cursor: (loading) ? 'not-allowed' : 'pointer'
              }}
              onClick={() => handleApply()}
            >
              <span className="material-icons-round" style={{ color: colors.softthinks }}>check_circle_outline</span>&nbsp;
              <span >{t('sidebar.filters.apply')}</span>
            </Button>
          </div>
        )}

        <hr />

        {/* {user.roleId > roles.stAdmin && (
        <h2 className="sidebar__title">
          {t('sidebar.scenarios.title')}
          </h2>
        )} */}

        {/* {user.roleId <= roles.stAdmin && (
          <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
            <ul className="dropdown__list" id="modeScenariosOrModules">
              <li onClick={() => handleSetModeScenariosOrModules('scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>{t('sidebar.scenarios.title')}</li>
              <li onClick={() => handleSetModeScenariosOrModules('modules')} style={{ textAlign: 'center', padding: '8px 12px' }}>{t('scenarios.modules.title', { s: 's' })}</li>
            </ul>

            <h2
              className="dropdown__content sidebar__title" style={{ textAlign: 'center' }}
              onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
            >
              <span className="dropdown__open"> </span>
              <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
              <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
        </h2>
          </div>
        )} */}

        {user.roleId === roles.user && (
          <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
            <ul className="dropdown__list" id="modeScenariosOrModules" >
              <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.all_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myGroup_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myGroup_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myShared_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myPrivate_scenarios')}
              </li>
            </ul>

            <h2
              className="dropdown__content sidebar__title" style={{ textAlign: 'center' }}
              onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
            >
              <span className="dropdown__open"> </span>
              <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
              <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
            </h2>
          </div>
        )}

        {user.roleId === roles.admin && (
          <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
            <ul className="dropdown__list" id="modeScenariosOrModules" >
              <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.all_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myGroup_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myGroup_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myShared_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myPrivate_scenarios')}
              </li>
            </ul>

            <h2
              className="dropdown__content sidebar__title" style={{ textAlign: 'center' }}
              onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
            >
              <span className="dropdown__open"> </span>
              <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
              <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
            </h2>
          </div>
        )}

        {user.roleId <= roles.stAdmin && (
          <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
            <ul className="dropdown__list" id="modeScenariosOrModules" >
              <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.all_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('sft_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.sft_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('allGroups_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.allGroups_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('currentGroups_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.currentGroups_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myShared_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('sidebar.scenarios.myPrivate_scenarios')}
              </li>
              <li onClick={() => handleSetModeScenariosOrModules('modules')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                {t('scenarios.modules.title', { s: 's' })}
              </li>
            </ul>

            <h2
              className="dropdown__content sidebar__title" style={{ textAlign: 'center' }}
              onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
            >
              <span className="dropdown__open"> </span>
              <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
              <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
            </h2>
          </div>
        )}


        {modeScenariosOrModules !== 'modules' && (
        <div className="scenarios">
          {loadingScenarios ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
              <BeatLoader css={{ height: '50px' }} color={colors.softthinks} />
            </div>
          ) : (
            <ul>
                {filteredScenarios?.length > 0 ? (
                  filteredScenarios
                    // .sort(function (a, b) {
                    //   if (user.scenariosOrder === null) {
                    //     return 0;
                    //   }

                    //   if (user.scenariosOrder.indexOf(a.id) === -1)
                    //     return 1;
                    //   if (user.scenariosOrder.indexOf(b.id) === -1)
                    //     return 1;

                    //   if (user.scenariosOrder.indexOf(a.id) < user.scenariosOrder.indexOf(b.id)) {
                    //     return -1;
                    //   }
                    //   return 1;
                    // })
                  .map((scenario, i) => {
                    const equal = isEqual(scenario, selectedScenario);

                    return (
                      <React.Fragment key={scenario.id}>
                        <li
                          title={scenario.label}
                          onClick={() => equal ? null : handleChangeScenario({ scenario })}
                            className={equal ? (loading ? 'scenario__item selected disabled' : 'scenario__item selected') : (loading ? 'scenario__item disabled' : 'scenario__item')}
                        >
                          <span className="text">{scenario.label}</span>

                          <span
                            className="material-icons-round"
                            title={t('scenarios.global_text')}
                            style={{ cursor: 'help', marginRight: -10 }}
                          >
                            {scenario.sharingOptions === sharingValues.everyone ? 'groups' : ''}
                          </span>
                        </li>

                        {/* {(scenarios[i + 1] && scenarios[i + 1].private && !scenario.private) && (
                          // Add bottom separation after last global scenario
                          <hr style={{ margin: '8px auto', width: '90%' }} />
                        )} */}
                      </React.Fragment>
                    );
                  })
              ) : (
                <li className="no__scenarios">
                  {t('sidebar.scenarios.' + (scenarios ? 'none' : 'select'), { count: (selected.locations ? selected.locations.length : 0) })}
                </li>
              )}
            </ul>
          )}
        </div>
        )}


        {modeScenariosOrModules === 'modules' && (
          <div className="scenarios">
            <ul>

              {modules?.length > 0 ? (
                modules.sort(function (a, b) {

                  if (Number(a) < Number(b))
                    return -1;
                  else
                    return 1;
                }).map((module, i) => {
                  const equal = isEqual(module, selectedModule);

                  if (Number(module) === -1)
                    return (<div></div>)

                  return (
                    <React.Fragment key={Number(module)}>
                      <li
                        disabled
                        title={t('scenarios.modules.' + module)}
                        onClick={() => equal ? null : handleChangeModule({ module })}
                        className={equal ? (loading ? 'scenario__item selected disabled' : 'scenario__item selected') : (loading ? 'scenario__item disabled' : 'scenario__item')}
                      >
                        <span className="text">
                          {Number(module) > 0 && module + ' - '}{t('scenarios.modules.' + module)}
                        </span>
                      </li>

                    </React.Fragment>
                  );
                })
              ) : (
                <li className="no__scenarios">
                  {t('sidebar.scenarios.' + (scenarios ? 'none' : 'select'), { count: (selected.locations ? selected.locations.length : 0) })}
                </li>
              )}

            </ul>
          </div>
        )}
      </div>
    </div>
  </>
}
